const Calc = {
  mmToPx(value: number) {
    return parseFloat(((value * this.getDPI()) / 25.4).toFixed(3))
  },
  pxToMm(value: number) {
    return parseFloat(((value * 25.4) / this.getDPI()).toFixed(1))
  },
  pxToIn(value: number) {
    return parseFloat((value / this.getDPI()).toFixed(3))
  },
  mmToIn(value: number, dec = 1) {
    return parseFloat((value / 25.4).toFixed(dec))
  },
  inToPx(value: number) {
    return parseFloat((value * this.getDPI()).toFixed(3))
  },
  inToMm(value: number) {
    return parseFloat((value * 25.4).toFixed(1))
  },
  pxToDPI(dpi: number, value: number) {
    return (Math.round(value) / this.getDPI()) * dpi
  },
  toFixed(num: number | string, fractionDigits: number) {
    return parseFloat(Number(num).toFixed(fractionDigits))
  },
  mmToFontsize(value: number) {
    // Font height should match selected font size
    // Reference: Letter A with font Arial
    return this.mmToPx(value) * 1.38
  },
  pxToFontsize(value: number) {
    return this.pxToMm(value) / 1.38
  },
  fontsizeToPx(value: number) {
    return this.mmToPx(value) * 1.38
  },
  getDPI() {
    return 96
  },
  scaleBounds(scale: number, bounds: Bounds) {
    bounds.left /= scale
    bounds.top /= scale
    bounds.width /= scale
    bounds.height /= scale
    return bounds
  },
  maxBounds(a: Bounds, b: Bounds) {
    return {
      left: Math.max(a.left, b.left),
      top: Math.max(a.top, b.top),
      width: Math.max(a.width, b.width),
      height: Math.max(a.height, b.height),
    }
  },
  imagePixelRatio() {
    if (window.devicePixelRatio && window.devicePixelRatio > 2) {
      return window.devicePixelRatio
    }

    return 2
  },
  toDeg(rad: number) {
    return rad * (180 / Math.PI)
  },
  toRad(deg: number) {
    return deg * (Math.PI / 180)
  },
  // solve triangle for e, given A, B, and d
  //                A
  //    |-------------------------/
  //    |                        /
  //    |                       /
  //    |                      /
  //    |                     /
  //    |                    /
  //    |                   /
  //    |                  /
  //    |                 /
  //    |                /
  //    |               /
  // B  |              /   C
  //    |             /
  //    |            /
  //    |           /
  //    |          /
  //    |         /
  //    |   e    /
  //    |-------/
  //    |     β/
  //    |     /
  //   d|    /
  //    |   /
  //    |  /
  //    |α/
  //    |/
  triangleHorizontalOffset(width: number, height: number, distance: number) {
    const C = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height, 2))
    const cosAlpha = (Math.pow(height, 2) + Math.pow(C, 2) - Math.pow(width / 2, 2)) / (2 * height * C)
    const alpha = Math.acos(cosAlpha)
    const beta = this.toRad(180 - 90 - this.toDeg(alpha))
    const e = (distance / Math.sin(beta)) * Math.sin(alpha)
    return parseFloat(e.toFixed(1))
  },
}

export default Calc
